import { AskField, Button, Field, Input, Label, Modal, Notice, Segmented, Select, Serif, Suggestion, Tag, Textarea, Title, Toggle, Turn, Wordmark } from '@raro/ui';
import { useState } from 'react';

/** As mesmas primitivas, nos dois temas. Serve para conferir que um componente novo funciona na machine e no MODO. */
function Specimen({ theme }: { theme: 'machine' | 'modo' }) {
  const [text, setText] = useState('');
  const [seg, setSeg] = useState('a');
  const [on, setOn] = useState(true);
  const [sel, setSel] = useState('rh');
  const [modal, setModal] = useState(false);
  const modo = theme === 'modo';
  return (
    <section data-theme={modo ? 'modo' : undefined} className="rr-stack rr-stack--5" style={{ padding: 'var(--rr-space-6)', border: '1px solid var(--rr-border)', borderRadius: 'var(--rr-radius-lg)', minWidth: 0 }}>
      <div className="rr-row rr-row--between"><Wordmark size={28}>{modo ? 'MODO' : 'machine'}</Wordmark><Tag>{modo ? 'tema modo' : 'tema machine'}</Tag></div>
      <div className="rr-stack rr-stack--2">
        <Label>rótulo</Label>
        <Title>{modo ? 'Boa tarde, Ana.' : 'o que aconteceu na machine.'}</Title>
        <p className="rr-muted" style={{ margin: 0 }}>texto de apoio, em tom secundário.</p>
        <Serif italic>"voz de pessoa, em serifa itálica."</Serif>
      </div>
      <div className="rr-row rr-row--wrap" style={{ gap: 8 }}>
        <Button variant="primary">ação principal</Button><Button variant="ghost">secundária</Button><Button variant="quiet">discreta</Button><Button variant="primary" size="sm" disabled>desligada</Button>
      </div>
      <div className="rr-row rr-row--wrap" style={{ gap: 12, alignItems: 'flex-start' }}>
        <Field label="Nome do relatório" htmlFor={`sp-n-${theme}`} hint="uma dica discreta"><Input id={`sp-n-${theme}`} placeholder="uso do produto por cidade" /></Field>
        <Field label="Departamento" htmlFor={`sp-s-${theme}`}><Select id={`sp-s-${theme}`} value={sel} onChange={(e) => setSel(e.target.value)}><option value="rh">RH</option><option value="comercial">Comercial</option><option value="unidades">Unidades</option></Select></Field>
      </div>
      <Field label="Recado" htmlFor={`sp-t-${theme}`}><Textarea id={`sp-t-${theme}`} rows={2} placeholder="um texto mais longo" /></Field>
      <div className="rr-row rr-row--wrap" style={{ gap: 16, alignItems: 'center' }}>
        <Segmented value={seg} onChange={setSeg} options={[{ value: 'a', label: 'tudo' }, { value: 'b', label: 'aprovados' }, { value: 'c', label: 'rascunhos' }]} />
        <Toggle checked={on} onChange={setOn} label="incluir o token" hint="uma opção com explicação" />
        <Tag tone="accent">destaque</Tag><Tag tone="outline">contorno</Tag>
      </div>
      <Notice>um aviso informativo.</Notice>
      <Notice tone="error">um aviso de erro.</Notice>
      <div className="rr-stack rr-stack--3">
        <Label>conversa</Label>
        <Turn who="me">Preciso de um A4 avisando que o bebedouro está em manutenção.</Turn>
        <Turn who="system">Encontrei algo que pode ajudar.</Turn>
        <AskField value={text} onChange={setText} onSubmit={() => setText('')} placeholder={modo ? 'O que você precisa fazer hoje?' : 'pergunte à machine'} onAttach={() => undefined} />
        <div className="rr-chip-row"><Suggestion onClick={() => setText('Card de WhatsApp para a vaga de recepcionista')}>Card de WhatsApp para uma vaga</Suggestion><Suggestion onClick={() => setText('Verificar um material')}>Verificar um material</Suggestion></div>
      </div>
      <div><Button variant="ghost" size="sm" onClick={() => setModal(true)}>abrir um modal</Button></div>
      {modal && <div data-theme={modo ? 'modo' : undefined} style={{ background: 'transparent' }}><Modal open onClose={() => setModal(false)} eyebrow="exemplo" title="Título do modal"><p className="rr-muted" style={{ margin: 0 }}>o conteúdo herda o tema de onde foi aberto.</p></Modal></div>}
    </section>
  );
}

/**
 * Sistema de design: um sistema, dois temas (docs/design/sistema-de-design-temas.md).
 * Página interna para conferir as primitivas lado a lado. Não é do produto.
 */
export function SistemaPage() {
  return (
    <div className="rr-page rr-stack rr-stack--6">
      <header className="rr-stack rr-stack--2">
        <Label>Sistema de design</Label>
        <Title>um sistema, dois temas.</Title>
        <p className="rr-muted">os mesmos componentes na machine (escura, densa, caixa alta, ação amarela) e no MODO (claro, silencioso, caixa normal, ação preta). o amarelo do MODO é só o ponto da marca.</p>
      </header>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(420px, 1fr))', gap: 'var(--rr-space-5)' }}>
        <Specimen theme="machine" />
        <Specimen theme="modo" />
      </div>
    </div>
  );
}
